dealershipModule.controller('DealerInfoController',
    ['$scope', 'dealershipService', 'DealerInfo', 'imSessionVarsService', 'commonTLCService', 'locationService','TLCError','AppErrorCodes',
    function ($scope, dealershipService, DealerInfo, imSessionVarsService, commonTLCService, locationService,TLCError,AppErrorCodes) {
        $scope.hasChanged = false;
        $scope.dealership = new DealerInfo();
        $scope.states = [];
        $scope.mastheadShowSearch = true;

        this.originalDealershipCopy = new DealerInfo();
        var dealerId = imSessionVarsService.getCurrentDealerIMId();
        var controller = this;

        init();

        function init() {
            if (imSessionVarsService.getShowcaseIntegrated() == 'true' )
                $scope.mastheadShowSearch = false;
            dealershipService.getDealership(dealerId)
                .then(function(dealer) {
                    $scope.dealership = dealer;
                    controller.originalDealershipCopy = angular.copy(dealer);
                }, function(error) {
                    throw new TLCError(new Error(error),AppErrorCodes.DealerController_GetDealerError);
                }, function(notifyMsg) {
                });

            commonTLCService.getStates()
                .then(function(response){
                    $scope.states = response;
                }, function(response) {
                    throw new TLCError(new Error(response),AppErrorCodes.DealerController_LoadStatesError);
                });
        }

        $scope.updateDealer = function() {
            // make request to update the database
            if($scope.hasChanged) {
                dealershipService.updateDealership(dealerId, $scope.dealership, controller.originalDealershipCopy)
                .then(function (response) {
                    // on success, make the dealership internal buffer match the model and reset the hasChanged flag
                    controller.originalDealershipCopy = angular.copy($scope.dealership);
                    $scope.hasChanged = false;
                }, function (response) {
                    var errorMessages = '';
                    if(response && response.data) {
                        if(angular.isArray(response.data)) {
                            errorMessages = response.data.map(function (error) {
                                return error.ErrorMessage;
                            }).join('; ');
                        } else {
                            errorMessages = response.data;
                        }
                    }
                    throw new TLCError(new Error(errorMessages),AppErrorCodes.DealerController_SaveDealerError);
                });
            }
        };

        $scope.revertChanges = function() {
            // restore the model to the old state kept in the buffer
            $scope.dealership = angular.copy(controller.originalDealershipCopy);
            $scope.hasChanged = false;
        };

        $scope.lookupDealershipLocationByZipCode = function(zipCode) {
            locationService.getLocationInfoFromZipCode(zipCode)
                .then(function(data) {
                    _.extend($scope.dealership, data);
                });
        };

        $scope.$watch('dealership', function(newValue, oldValue) {
            $scope.hasChanged = !angular.equals($scope.dealership, controller.originalDealershipCopy);

        }, true); // this 'true' param is essential - it tells the watch to do a value comparison, not a reference compare. Without it, the watch will never run unless you create a new object!
    }
]);
